/**
 * ==========================================
 * TOP BAR FIGMA - PREMIÈRE BARRE
 * ==========================================
 *
 * Composant basé exactement sur les spécifications Figma
 * - Background vert #22A922
 * - Sélecteur de langue avec design exact
 * - Bouton FAQ avec icône shield-exclamation
 */

import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ProductionTranslationService } from '../../core/services/production-translation.service';
import { Subscription } from 'rxjs';

import { SharedModule } from '../../shared/shared.module';

@Component({
    selector: 'app-top-bar-figma-new',
    templateUrl: './top-bar-figma.component.html',
    styleUrls: ['./top-bar-figma.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [SharedModule]
})
export class TopBarFigmaComponent implements OnInit, OnDestroy {

  // État de la langue actuelle
  currentLanguage: string = 'en'; // EN actif par défaut selon Figma
  private languageSubscription?: Subscription;

  constructor(
    private router: Router,
    public translationService: ProductionTranslationService
  ) {}

  ngOnInit(): void {
    // Détecter la langue actuelle
    this.currentLanguage = this.translationService.getCurrentLanguage();

    // S'abonner aux changements de langue
    this.languageSubscription = this.translationService.currentLanguage$.subscribe(
      (language) => {
        this.currentLanguage = language;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  // ==========================================
  // GESTION DES LANGUES (FIGMA)
  // ==========================================

  setLanguage(language: string): void {
    this.currentLanguage = language;
    this.translationService.changeLanguage(language).subscribe({
      next: () => {
        console.log(`Language changed to: ${language}`);
      },
      error: (error) => {
        console.error('Language change error:', error);
      }
    });
  }

  // ==========================================
  // NAVIGATION FAQ (FIGMA)
  // ==========================================

  navigateToFAQ(): void {
    this.router.navigate(['/faq']);
  }
}